module.exports = __webpack_public_path__ + "static/media/planet-moon.326d776b.svg";